import React from 'react';

import { Map } from 'immutable';
import { createStructuredSelector, Selector } from '@opengov/compose-app/reselect';
import { IReactComponent } from '@opengov/compose-app/types';

import { getRouteComponent, getRouteProps } from '../selectors';

type IRouteProps = { component?: IReactComponent<any>; props?: any };

export const selectRouteProps = createStructuredSelector<any, IRouteProps>({
  component: getRouteComponent,
  props: getRouteProps
});

export function RouterRootView<PAGEPROPS extends {}>(
  PageComponent: IReactComponent<PAGEPROPS>,
  selectPageProps: Selector<any, PAGEPROPS>
) {
  const pageSelector = createStructuredSelector({
    pageProps: selectPageProps,
    routeProps: selectRouteProps
  });

  return (props: { state: Map<string, any> }) => {
    const { pageProps, routeProps } = pageSelector(props.state);
    if (!routeProps.props || !routeProps.component) {
      return <PageComponent {...pageProps} />;
    }

    const RouteComponent = routeProps.component;

    return (
      <PageComponent {...pageProps}>
        <RouteComponent {...routeProps.props} />
      </PageComponent>
    );
  };
}
